import React from 'react';
import { SearchIcon } from 'lucide-react';
import CategoryList from '../components/CategoryList';
const Categories = () => {
  // Mock data for categories
  const categories = [{
    id: 'sports',
    name: 'Sports & Fitness',
    icon: '🏃',
    count: 45
  }, {
    id: 'arts',
    name: 'Arts & Culture',
    icon: '🎨',
    count: 32
  }, {
    id: 'prof',
    name: 'Professional',
    icon: '💼',
    count: 28
  }, {
    id: 'hobbies',
    name: 'Hobbies',
    icon: '🎮',
    count: 37
  }, {
    id: 'volunteer',
    name: 'Volunteering',
    icon: '🤲',
    count: 19
  }, {
    id: 'education',
    name: 'Education',
    icon: '📚',
    count: 24
  }];
  return <div className="p-4" data-id="element-872">
      <h1 className="text-2xl font-bold mb-4" data-id="element-873">Categories</h1>
      <div className="relative mb-4" data-id="element-874">
        <input type="text" placeholder="Search categories..." className="w-full p-2 pl-10 border border-gray-300 rounded-lg" data-id="element-875" />
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" data-id="element-876" />
      </div>
      <CategoryList categories={categories} data-id="element-877" />
      <div className="mb-4" data-id="element-878">
        <h2 className="text-lg font-medium mb-2" data-id="element-879">Featured Categories</h2>
        <div className="border border-gray-300 rounded-lg p-4" data-id="element-880">
          <div className="flex justify-between items-center" data-id="element-881">
            <div data-id="element-882">
              <h3 className="font-bold" data-id="element-883">Tech Communities</h3>
              <p className="text-sm text-gray-600 mt-1" data-id="element-884">
                Connect with tech enthusiasts across Kenya
              </p>
            </div>
            <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center border border-dashed border-gray-400" data-id="element-885">
              <span className="text-gray-500" data-id="element-886">💻</span>
            </div>
          </div>
          <button className="mt-3 w-full border border-gray-300 rounded-md py-2 text-sm" data-id="element-887">
            Explore
          </button>
        </div>
      </div>
    </div>;
};
export default Categories;